var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SelectPatientTable',{attrs:{"columns":_vm.columns,"patient":_vm.localValue.patient,"hide-selected-patient":""},on:{"update:patient":function($event){return _vm.$set(_vm.localValue, "patient", $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }